import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {SpecialistDecision} from 'app/departures/departure/tech-specialist-view/specialist-decision';

@Component({
  selector: 'das-specialist-recommendation',
  templateUrl: './specialist-recommendation.component.html',
  styleUrls: ['./specialist-recommendation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpecialistRecommendationComponent {
  private static readonly DISPLAY_STRINGS: Record<SpecialistDecision, string> = {
    [SpecialistDecision.APPROVED]: 'approved',
    [SpecialistDecision.APPROVED_WITH_CONDITIONS]: 'approved with conditions',
    [SpecialistDecision.REJECTED]: 'rejected',
    [SpecialistDecision.REWORK_REQUIRED]: 'sent for rework'
  };

  @Input()
  public set recommendation(recommendation: SpecialistDecision) {
    this.class = recommendation === SpecialistDecision.REJECTED ? 'bad' : 'good';
    this.displayString = this.generateDisplayString(recommendation);
  }

  public class: string;
  public displayString: string;

  private generateDisplayString(recommendation: SpecialistDecision): string {
    if (recommendation) {
      return SpecialistRecommendationComponent.DISPLAY_STRINGS[recommendation] || recommendation.toLowerCase();
    } else {
      return null;
    }
  }
}
